var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMysteryGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 39l26-5 26 5v34l-20.7 8h-10L24 73z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9 34.5h-8.7a8.7 8.7 0 002.5-6.2c0-5.3-4-9.3-9.3-9.3-3.1 0-8.7 2.8-12.4 6.5-3.7-3.7-9.3-6.5-12.4-6.5-5.3 0-9.3 4-9.3 9.3 0 2.5 1 4.6 2.5 6.2H22c-1.9 0-3.1 1.2-3.1 3.1v8.7c0 .3.3.6.6.6h26c.7 0 1.3-.6 1.3-1.2v-10c0-.6.6-1.2 1.2-1.2H52c.6 0 1.2.6 1.2 1.2v10c0 .6.6 1.2 1.2 1.2h26c.4 0 .7-.3.7-.6v-8.7c0-1.9-1.2-3.1-3.1-3.1zm-40.3-3.1c-1.9 0-3.1-1.2-3.1-3.1 0-1.9 1.2-3.1 3.1-3.1 1.9 0 7.4 3.7 9 5.6-1 .3-9 .6-9 .6zm24.8 0s-8-.3-9-.6c1.9-2.2 7.1-5.6 9-5.6 1.9 0 3.1 1.2 3.1 3.1 0 1.9-1.2 3.1-3.1 3.1zM47.7 53.1h-23c-.3 0-.6.3-.6.6V78c0 1.9 1.2 3.1 3.1 3.1h20.5c.6 0 1.2-.6 1.2-1.2V54.3c0-.6-.6-1.2-1.2-1.2zM75.3 53.1h-23c-.6 0-1.2.6-1.2 1.2v25.5c0 .6.6 1.2 1.2 1.2h20.5c1.9 0 3.1-1.2 3.1-3.1V53.7c0-.3-.3-.6-.6-.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40 49.5c0-1.4.5-2.7 1.3-4a9.9 9.9 0 013.8-3.5c1.6-.9 3.5-1.3 5.7-1.3 2 0 3.8.4 5.4 1.1 1.5.8 2.7 1.8 3.6 3a7.5 7.5 0 01.5 7.4c-.4.9-1 1.7-1.7 2.3A125.6 125.6 0 0154 59a4.6 4.6 0 00-1 1.7l-.3 1.4c-.3 1.5-1.1 2.2-2.5 2.2-.7 0-1.4-.2-1.9-.7-.5-.5-.7-1.2-.7-2.1 0-1.2.2-2.2.5-3 .4-1 .9-1.7 1.5-2.4l2.4-2.3 2-1.8a6 6 0 001-1.3c.3-.5.4-1 .4-1.6 0-1.1-.4-2-1.3-2.8-.8-.8-1.9-1.2-3.2-1.2-1.5 0-2.7.4-3.4 1.2-.7.8-1.3 2-1.8 3.4-.5 1.6-1.4 2.4-2.7 2.4-.8 0-1.5-.3-2-.8-.6-.6-.8-1.2-.8-1.8zm10.3 23c-.8 0-1.6-.3-2.2-.8a3 3 0 01-1-2.4 3.1 3.1 0 013.2-3.1 3 3 0 012.2 1c.6.5 1 1.3 1 2.1a3 3 0 01-1 2.3c-.6.6-1.4.9-2.2.9z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMysteryGift);
export default __webpack_public_path__ + "static/media/mystery_gift.c018c9820eccdaebd165ed5974b792ce.svg";
export { ForwardRef as ReactComponent };